import { ReactNode } from 'react'
import { GeoShape } from './Types'
import { SvgExportDef } from '@tldraw/tldraw'
import { FrameShape } from '../FrameShape/Types'

type FillGradientResult = {
  id: string
  defs: ReactNode
  defsHtmlString: string | null
  svgExportDef: SvgExportDef
}

export const getFillGradient = (shape: GeoShape | FrameShape): FillGradientResult => {
  const { fill } = shape.props
  const id = `${shape.id}_fill-gradient`

  if (fill.type !== 'linearGradient') {
    return {
      id,
      defs: null,
      defsHtmlString: null,
      svgExportDef: {
        key: id,
        getElement: () => [],
      },
    }
  }

  const { angle, stops } = fill

  const coords = {
    x1: 50 - Math.cos(angle * (Math.PI / 180)) * 50 + '%',
    x2: 50 + Math.cos(angle * (Math.PI / 180)) * 50 + '%',
    y1: 50 - Math.sin(angle * (Math.PI / 180)) * 50 + '%',
    y2: 50 + Math.sin(angle * (Math.PI / 180)) * 50 + '%',
  }

  const defsHtmlString = `
    <linearGradient id="${id}" x1="${coords.x1}" x2="${coords.x2}" y1="${coords.y1}" y2="${coords.y2}">
      ${stops
        .map((stop) => `<stop stop-color="${stop.color}" stop-opacity="${stop.opacity}" offset="${stop.position}" />`)
        .join('')}
    </linearGradient>
  `

  return {
    id,
    defs: (
      <linearGradient id={id} {...coords}>
        {stops.map((stop, i) => (
          <stop key={i} stopColor={stop.color} stopOpacity={stop.opacity} offset={stop.position} />
        ))}
      </linearGradient>
    ),
    defsHtmlString,
    svgExportDef: {
      key: id,
      getElement: () => {
        const divEl = document.createElement('div')
        divEl.innerHTML = `
          <svg>
            <defs>
              ${defsHtmlString}
            </defs>
          </svg>
        `
        return Array.from(divEl.querySelectorAll('defs > *'))
      },
    },
  }
}
